//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getIndustry,getMajor} from '@/assets/js/dict';
import {options} from '@/assets/js/city';
import { map } from '@/assets/js/map';
export default({
    created() {
      getIndustry().then(res=>{
        this.industryList =res;
      })
      getMajor().then(res =>{
        this.majors = res;
      })
      this.options=options;
      this.mapList=map;
    },
    data(){
        return {
            id:'',
            leix:1,
            dialogVisible:false,
            industryList:[],
            majors:[],
            form:{
                title:'', //关键字
                industry: '', //行业
                addressCode:'', //专家地点
                isExpert: true, //是否专家
                pageSize: 10,
                pageIndex: 1,
                currentUserType:'3',
                relationId:'',
                assessType:''
            },
            forms: {
                currentUserType:'3',
                relationId:'',
                pageIndex: 1,
                pageSize: 6,
                sortName: '',
                sortOrder: 'ASC',
                title: '',
                total: 10,
                assessType:'2',
                collectType:1,
                industry:'',
            },
            personList:[], //专家列表
            collectList:[], // 收藏列表
            personId:'',
            loading:false,
            finished:false,
            //推荐专家
            recommendVisible:false,
            recomForm:[
                {
                    major:'',
                    contactAddressCode:'',
                    peopleNum:'',
                    traProjectId:'',
                }
            ],
        }
    },
    methods:{
        //弹窗显示(选择专家)
        openDialog(traProjectId,id){
            this.personId = id
            this.form.title=''; //关键字
            this.form.industry=''; //行业
            this.form.addressCode=''; //专家地点
            this.form.isExpert=true; //是否专家
            this.id =traProjectId;
            this.form.pageIndex=1;
            this.form.relationId= traProjectId;
            this.forms.relationId =traProjectId;
            this.dialogVisible=true
            this.personList=[]
            // this.getList()
        },
        // 专家列表
        getList(){
            this.form.relationId= this.$route.query.id
            this.$get('/sys/user/list/invitation',this.form,function(res){
               var newArr = res.data.records;
               if (!newArr || newArr.length === 0) {
                    this.finished = true
                } else {
                    this.personList.push(...newArr)
                    this.form.pageIndex = this.form.pageIndex + 1
                }
                this.loading = false
            })
        },

        //收藏列表
        getCollect(){
            this.$get('/sys/user/list/collect',this.forms,function(res){
                var newArr = res.data.records;
               if (!newArr || newArr.length === 0) {
                    this.finished = true
                } else {
                    this.collectList.push(...newArr)
                    this.forms.pageIndex = this.forms.pageIndex + 1
                }
                this.loading = false
            })
        },
        // 点击搜索
        onSearch(){
            this.form.pageIndex=1;
            this.forms.pageIndex=1;
            this.personList=[];
            this.collectList=[];
            this.form.addressCode= this.form.addressCode.toString()
            if(this.leix==1){
                this.getList();
            }else{
                this.getCollect()
            }
        },
        // 切换专家和收藏专家列表
        changeT(index){
            this.leix=index
            if(index==1){
                this.form.pageIndex=1;
                this.personList=[];
                this.getList()
            }else{
                this.forms.pageIndex=1;
                this.collectList=[];
                this.getCollect()
            }
        },
        // 选择专家
        ensurePerson(item){
            var ids=[];
            ids.push(item.id);
            if(this.personId){
                //替换专家
                this.$put('/tra/project/bid/replaceUser?id='+this.personId+'&userId='+item.id,'',function(res){
                    if(res.code==200){
                        this.dialogVisible=false
                        this.$message.success('替换成功!');
                        this.$parent.getIsExtract();
                    }
                },true)
            }else{
                //选择专家
                this.$post('/tra/project/bid/invitation',{
                    traProjectId:this.id,
                    userIds:ids,
                },function(res){
                    if(res.code==200){
                        if(this.leix==1){
                            this.form.pageIndex=1;
                            this.personList=[]
                            this.getList()
                        }else{
                             this.forms.pageIndex=1;
                            this.collectList=[]
                            this.getCollect()
                        }
                        this.$message.success('选择成功!');
                        this.$parent.getIsExtract();
                    }
                },true)
            }
        },
        // 推荐专家弹窗
        openRecommend(){
            this.recommendVisible= true
        },
        // 增加推荐专业人才
        addRecom(){
            this.recomForm.push({
            major:'',
            contactAddressCode:'',
            peopleNum:'',
            traProjectId:this.$route.query.id
            })
        },

        //删除推荐条件
        removeRecom(index){
            this.recomForm.splice(index, 1)
        },

        // 确定推荐专家条件
      ensureRecom(){
        var recomForm = this.recomForm;
        for(var i=0;i<recomForm.length;i++){
          recomForm[i].traProjectId=this.$route.query.id
          recomForm[i].contactAddressCode= recomForm[i].contactAddressCode.toString()
        }
        this.$post('/tra/project/extract/record/recommend',recomForm,function(res){
          if(res.code==200){
            if(res.data==0){
              this.$message.info('当前专业地点无合适专家')
            }else{
              this.$message.success('已成功为您推荐'+res.data+'位专家')
            }
            this.recommendVisible=false
            this.$parent.getIsExtract()
          }
        },true)
      },


    },
    mounted(){
        
        
    }
})
